import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: ()=>import('@/components/Login/login')
    },
    {
      path: "/index",
      name:"index",
      component: ()=>import("@/components/Index/index"),
      redirect:"tab1",
      children:[
        {
          path:"tab1",
          name:"tab1",
          component:()=>import("@/components/tab1/tab1"),
          meta:{
            keepAlive:true
          }
        },
        {
          path:"tab2",
          name:"tab2",
          component:()=>import("@/components/tab2/tab2"),
          meta:{
            keepAlive:true
          }
        },
        {
          path:"tab3",
          name:"tab3",
          component:()=>import("@/components/tab3/tab3"),
          meta:{
            keepAlive:true
          }
        },
        {
          path:"tab4",
          name:"tab4",
          component:()=>import("@/components/tab4/tab4"),
          meta:{
            keepAlive:true
          }
        },
        {
          path:"tab5",
          name:"tab5",
          component:()=>import("@/components/tab5/tab5"),
          meta:{
            keepAlive:true
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js